/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceMoveToRequest
 */
export interface WorkspaceMoveToRequest {
    /**
     * 
     * @type {number}
     * @memberof WorkspaceMoveToRequest
     */
    production: number;
}

export function WorkspaceMoveToRequestFromJSON(json: any): WorkspaceMoveToRequest {
    return WorkspaceMoveToRequestFromJSONTyped(json, false);
}

export function WorkspaceMoveToRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMoveToRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'production': json['production'],
    };
}

export function WorkspaceMoveToRequestToJSON(value?: WorkspaceMoveToRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'production': value.production,
    };
}


